/**
 * Main App
 */
// import React from 'react';
// import { Provider } from 'react-redux';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import '@fontsource/ubuntu';

// // CSS
// import './lib/reactifyCss';
// import './style.css';

// // Firebase setup
// import './firebase';

// // App container and store
// import App from './container/App';
// import { configureStore } from './store';

// const MainApp = () => (
//   <Provider store={configureStore()}>
//     <LocalizationProvider dateAdapter={AdapterMoment}>
//       <Router>
//         <Routes>
//           <Route path="/*" element={<App />} />
//         </Routes>
//       </Router>
//     </LocalizationProvider>
//   </Provider>
// );

// export default MainApp;

/**
 * Main App
 */
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// CSS
import './lib/reactifyCss';
import './style.css';
import './lib/registerChartJs';




// Firebase setup
import './firebase';

// App container and store
import App from './container/App';
import { configureStore } from './store';

const store = configureStore();

const MainApp = () => (
  <HelmetProvider>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Router>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </Router>
      </LocalizationProvider>
    </Provider>
  </HelmetProvider>
);

export default MainApp;

